// VFX: Terminal Code Block
// Category: device-mockups · Tags: ui, terminal, code, typewriter, dev
// Bloco de terminal estilo macOS com texto que digita linha por linha.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

type Line = { text: string; type: "command" | "output" | "success" | "error" | "comment" };

const LINES: Line[] = [
  { text: "$ npx remotion render", type: "command" },
  { text: "Bundling...", type: "output" },
  { text: "Rendered 300 frames", type: "success" },
  { text: "Exported: video.mp4 (14MB)", type: "success" },
];

const TYPE_COLORS: Record<string, string> = {
  command: "#f8fafc", output: "#94a3b8", success: "#10b981", error: "#ef4444", comment: "#475569",
};

export default function UiTerminalBlockTypewriter1500Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const p = spring({ frame, fps, config: { damping: 120, stiffness: 160 } });
  const framesPerChar = 2;
  const charsToShow = Math.floor((frame - 10) / framesPerChar);

  return (
    <AbsoluteFill style={{ background: "#0a0e1a", justifyContent: "center", alignItems: "center" }}>
      <div style={{
        width: 620, borderRadius: 12, overflow: "hidden",
        opacity: p, transform: `translateY(${interpolate(p, [0, 1], [40, 0], clamp)}px)`,
        boxShadow: "0 2px 4px rgba(0,0,0,0.8), 0 8px 32px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06)",
      }}>
        <div style={{ height: 38, background: "#2c2c2e", display: "flex", alignItems: "center", padding: "0 14px", gap: 7 }}>
          {["#ff5f57", "#ffbd2e", "#28c840"].map((c, i) => (
            <div key={i} style={{ width: 12, height: 12, borderRadius: "50%", background: c }} />
          ))}
          <span style={{ flex: 1, textAlign: "center", fontSize: 12, color: "rgba(255,255,255,0.4)", fontFamily: "system-ui" }}>Terminal</span>
        </div>
        <div style={{ background: "#1a1a1c", padding: "20px 20px", minHeight: 240 }}>
          {LINES.map((line, li) => {
            const lineStart = LINES.slice(0, li).reduce((s, l) => s + l.text.length, 0);
            if (charsToShow < lineStart) return null;
            const charsInThisLine = Math.max(0, Math.min(line.text.length, charsToShow - lineStart));
            const color = TYPE_COLORS[line.type];
            return (
              <div key={li} style={{
                fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
                fontSize: 14, color, marginBottom: 6, lineHeight: 1.6, whiteSpace: "pre",
              }}>
                {line.text.slice(0, charsInThisLine)}
                {charsInThisLine < line.text.length && (
                  <span style={{ opacity: Math.sin(frame * 0.3) > 0 ? 1 : 0 }}>▌</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
